module.exports = __webpack_public_path__ + "img/logo-white.35d6c81c.png";